// src/pages/Home.js
import React, { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';
import heroimage from '../assets/images/hero-img.png';
import playIcon from '../assets/images/icon-play.svg';
import clientLogo1 from '../assets/images/client-logo-1.svg';
import clientLogo2 from '../assets/images/client-logo-2.svg';
import clientLogo3 from '../assets/images/client-logo-3.svg';
import Paymentgateway from './Paymentgateway';
import { AboutUs, OurServices, WhyChooseUs, OurFeature, FactCounter, WhatWeDo, HowItWork, OurPricing, OurFaqs, OurTestimonial, OurBlog } from './Homepage';

function Home() {
  const swiperRef = useRef(null);

  // Helper component for animated characters
  const AnimatedCharacter = ({ char }) => (
    <div style={{
      position: "relative",
      display: "inline-block",
      opacity: 1,
      visibility: "inherit",
      transform: "translate(0px, 0px)"
    }}>
      <div style={{ position: "relative", display: "inline-block" }}>
        <div style={{
          position: "relative",
          display: "inline-block",
          transform: "translate(0px, 0px)",
          opacity: 1
        }}>
          {char}
        </div>
      </div>
    </div>
  );

  // Helper component for animated text lines
  const AnimatedTextLine = ({ text }) => (
    <div className="split-line" style={{
      display: "block",
      textAlign: "start",
      position: "relative"
    }}>
      <span>
        {text.split('').map((char, index) => (
          <AnimatedCharacter key={index} char={char} />
        ))}
      </span>
    </div>
  );

  const titleLines = [
    "Empowering",
    "financial",
    "success"
  ];

  const clientLogos = [clientLogo1, clientLogo2, clientLogo3, clientLogo1, clientLogo2, clientLogo3];

  return (
    <div>
      <div className="hero">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="hero-content">
                <div className="section-title dark-section">
                  <h3 className="wow fadeInUp" style={{ visibility: "visible", animationName: "fadeInUp" }}>
                    Welcome to Payinfintech
                  </h3>
                  <h1 className="text-anime-style-2 text-success" data-cursor="-opaque" style={{ perspective: 400 }}>
                    Your Trusted Partner for KYC & Security API Solutions

                    {/* {titleLines.map((line, index) => (
                      <AnimatedTextLine key={index} text={line} />
                    ))} */}
                  </h1>
                  <p
                    className="wow fadeInUp"
                    data-wow-delay="0.2s"
                    style={{
                      visibility: "visible",
                      animationDelay: "0.2s",
                      animationName: "fadeInUp"
                    }}
                  >
                    We help businesses automate identity verification and secure transactions with robust API infrastructure. From seamless onboarding to regulatory compliance and fraud prevention — we simplify complex security protocols so you can focus on growth.</p>
                </div>

                <div
                  className="hero-content-body wow fadeInUp"
                  data-wow-delay="0.4s"
                  style={{
                    visibility: "visible",
                    animationDelay: "0.4s",
                    animationName: "fadeInUp"
                  }}
                >
                  <div className="hero-btn">
                    <a href="/contact" className="btn-default">
                      get started
                    </a>
                  </div>

                  <div className="hero-introduction-video">
                    <div className="video-play-button">
                      <a
                        href="#"
                        className="popup-video"
                        data-cursor-text="Play"
                      >
                        <img src={playIcon} alt="Play introduction video" />
                      </a>
                      <p>KYC & Security Integrations</p>
                    </div>
                  </div>
                </div>


              </div>
            </div>

            <div className="col-lg-6">
              <div className="hero-image">
                <div className="hero-img">
                  <figure>
                    <img src={heroimage} alt="Financial consulting services" />
                  </figure>
                </div>

                <div className="company-experience">
                  <h3>
                    <span className="counter">5</span>+
                  </h3>
                  <p>Extensive Experience in Identity Verification & API Security</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AboutUs />
      {/* <OurServices /> */}
      <WhyChooseUs />
      {/* <Paymentgateway /> */}

      <OurFeature />
      <FactCounter />
      <WhatWeDo />
      <HowItWork />
      <OurPricing />
      <OurFaqs />
      {/* <OurTestimonial /> */}
      <OurBlog />
    </div>
  );
}

export default Home;